export const HEADER_FIRST_LINE = {
  class: 'font-weight-bold primary--text',
  style: 'font-size: 14px;',
};

export const HEADER_SECOND_LINE = {
  class: 'font-weight-regular primary--text',
  style: 'font-size: 14px;',
};

export const REQUEST_FIRST_LINE = {
  class: 'font-weight-bold white--text',
  style: 'font-size: 14px;',
};

export const REQUEST_SECOND_LINE = {
  class: 'font-weight-regular white--text',
  style: 'font-size: 14px;',
};

export const BODY_FIRST_LINE = {
  class: 'font-weight-regular charcoal--text',
  style: 'font-size: 14px;',
};

export const BODY_SECOND_LINE = {
  class: 'font-weight-light charcoal--text',
  style: 'font-size: 14px;',
};

export const BODY_SECOND_LINE_STATUS = {
  class: 'font-weight-light charcoal--text d-flex justify-start',
  style:
    'font-size: 14px; background: var(--v-tableLine-base) 0% 0% no-repeat padding-box; border-radius: 10px; padding: 0 14px;',
};

export const SELECT_FOOTER = {
  style: "max-width: 80px; width: 80px; margin-right: 50px; font-size: 14px;",
}

export const LABEL_FOOTER = {
  class: 'font-weight-regular darkGray--text',
  style: "font-size: 14px; margin-right: 50px; ",
}